import acceptSharedCalendarInvite from '../services/acceptSharedCalendarInvite';
import { getUserMailboxId } from 'owa-client-ids';
import { addSelectedCalendar } from 'owa-calendar-module-selected-calendars-user-config';
import ItemId from 'owa-service/lib/contract/ItemId';
import { action } from 'satcheljs/lib/legacy';

const acceptInvite = action('acceptInvite')(function acceptInvite(
    sharingInviteItemId: ItemId
): Promise<boolean> {
    return acceptSharedCalendarInvite(sharingInviteItemId)
        .then(response => {
            if (response.ResponseClass == 'Success' && response.NewCalendarEntryId) {
                // select the new calendar
                addSelectedCalendar(response.NewCalendarEntryId.Id, getUserMailboxId());
            }

            return new Promise<boolean>(resolve => {
                resolve(response.ResponseClass == 'Success');
            });
        })
        .catch(() => Promise.reject('[acceptSharedCalendarInvite] failed'));
});

export default acceptInvite;
